import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
const Milestone = () => {
  return (
    <>
      <Header />
      <Breadcrumb pageTitle="Milestone" breadcrumbName="Milestone" />

      <div className="container body_height">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
            <div className="syllabus">
              {" "}
              <Link
                to="https://online.fliphtml5.com/iqzpj/dmbo/"
                target="_blank"
              >
                {" "}
                Volume XV Session: 2024-25{" "}
              </Link>{" "}
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
            <div className="syllabus">
              {" "}
              <Link
                to="https://heyzine.com/flip-book/4d4b7db4f1.html"
                target="_blank"
              >
                {" "}
                Volume XIII Session: 2023-24{" "}
              </Link>{" "}
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
            <div className="syllabus">
              {" "}
              <Link
                to="https://heyzine.com/flip-book/7b83524add.html#page/1"
                target="_blank"
              >
                {" "}
                Volume XII Session: 2022-23{" "}
              </Link>{" "}
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
            <div className="syllabus">
              {" "}
              <Link
                to="https://heyzine.com/flip-book/059b8a7b21.html#page/1"
                target="_blank"
              >
                {" "}
                Volume XI Session: 2021-22{" "}
              </Link>{" "}
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6">
            <div className="syllabus">
              {" "}
              <Link
                to="https://webapi.entab.info/api/image/AFGJI/public/pdf/Newsletter.pdf"
                target="_blank"
              >
                {" "}
                Volume X Session: 2020-21{" "}
              </Link>{" "}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Milestone;
